import { DateTime } from 'luxon';

import LastSavedTimeIndicator from '~/components/maud/patients/note/LastSavedTimeIndicator';

type Props = {
  networkErrorString: string | null;
  isGetNoteDataLoading: boolean;
  isUpdateNoteLoading: boolean;
  isNoteAutoSaving: boolean;
  lastSavedTime: DateTime | null;
};
export const EditNoteAccordionFooterNetworkStatus = ({
  networkErrorString,
  isGetNoteDataLoading,
  isUpdateNoteLoading,
  isNoteAutoSaving,
  lastSavedTime,
}: Props) => {
  if (networkErrorString) {
    return <>{networkErrorString}</>;
  } else if (isUpdateNoteLoading) {
    return <>Saving note...</>;
  } else if (isGetNoteDataLoading) {
    return <>Fetching note...</>;
  } else if (isNoteAutoSaving) {
    return <>Auto saving...</>;
  }

  return <LastSavedTimeIndicator lastSavedTime={lastSavedTime} />;
};
